<script setup lang="ts">
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ArrowLeft, ClipboardList, ListChecks, UserRound } from "lucide-vue-next";

const route = useRoute();
const router = useRouter();
const isAdmin = computed(() => Boolean(route.meta.admin));
const isBare = computed(() => Boolean(route.meta.bare));
const showBottom = computed(() => !isAdmin.value && !isBare.value && !route.meta.back);
</script>

<template>
  <div :class="isAdmin ? 'admin-app' : 'driver-app'">
    <header v-if="!isAdmin && !isBare" class="app-header">
      <button v-if="route.meta.back" class="icon-button" aria-label="返回" @click="router.back()"><ArrowLeft :size="22" /></button>
      <span v-else class="header-spacer" />
      <strong>{{ route.meta.title }}</strong>
      <span class="header-spacer" />
    </header>
    <main :class="{ 'driver-main': !isAdmin && !isBare, 'with-bottom': showBottom }">
      <RouterView v-slot="{ Component }"><component :is="Component" /></RouterView>
    </main>
    <nav v-if="showBottom" class="bottom-nav" aria-label="主导航">
      <RouterLink to="/" :class="{ active: route.path === '/' }"><ClipboardList :size="21" /><span>任务广场</span></RouterLink>
      <RouterLink to="/my" :class="{ active: route.path === '/my' }"><ListChecks :size="21" /><span>我的任务</span></RouterLink>
      <RouterLink to="/profile" :class="{ active: route.path === '/profile' }"><UserRound :size="21" /><span>我的</span></RouterLink>
    </nav>
  </div>
</template>
